const $ = require('jquery');
window.$ = window.jQuery = $;

require('./inter');

const Popper = require('popper.js');
window.Popper = Popper;

require('bootstrap');
require('../scss/index.scss');

// Require toast notifications for all pages where Bootstrap toasts are needed
require('./toast.js');
// Persist and propagate selected OMS company context.
require('./companySelection.js');
// Require My Vendors functionality (favorites, ratings) for /oms/business/my_vendors pages
require('../../oms/business/my_vendors/js/mvn.js');
